<template>
  <div class="bg-style text-center">
    <div>
      <img src="../../assets/inseeApp.png" class="img mb-5" />
    </div>
    <h3 style="color: #9e1c20">
      ສາມາດດາວໂຫລດ Insee Hub ໄດ້ທີ່ Play store & Apple sore
    </h3>
    <p>
      ໂຫລດແລ້ວລວຍເລີຍ ຮັບ 5,000ກີບ ເມື່ອໂຫລດ Insee Hub Super App <br />
      ພ້ອມຮັບສ່ວນຫລຸດ 10% ທຸກຄັ້ງທີຊື້ຜ່ານແອັບ ຕັ້ງແຕ່ 10,000ກີບຂຶ້ນໄປ
    </p>

    <div>
      <a
        v-for="(item, index) in items"
        :key="item.id"
        :href="item.link_url"
        target="_blank"
      >
        <img
          :src="hoverIndex === index ? hoverImg[index] : Img[index]"
          class="btn mx-2"
          @mouseover="hoverIndex = index"
          @mouseleave="hoverIndex = null"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import { genSignature } from "@/plugins/gen";
export default {
  data() {
    return {
      Img: [
        require("../../assets/Play store.png"),
        require("../../assets/App store.png"),
      ],
      hoverImg: [
        require("../../assets/Play store-hover.png"),
        require("../../assets/App store-hover.png"),
      ],
      hoverIndex: null,
    };
  },
  computed: {
    ...mapGetters("downLoader", ["items", "textt"]),
  },
  methods: {
    ...mapActions("downLoader", ["Downl"]),
  },
  async mounted() {
    await this.Downl();
  },
};
</script>

<style scoped>
* {
  -webkit-user-drag: none;
}
.btn_dl {
  display: flex;
  justify-content: center;
}
.btn {
  height: 60px;
}
.img {
  width: 100px;
  height: 100px;
}
.bg-style {
  background-color: #f6e9e9;
  padding: 25px;
}
</style>
